<template>
  <div v-if="menu.Categories" class="row mt-1">
    <div
      ref="scrollview"
      class="col-sm-12 pr-spc section-search-cls scrollview"
      v-if="menu.Categories.length > 0"
      :style="'height:' + getscrollheight + 'px;position: fixed;'"
    >
      <!-- combos category -->
      <shop-populars @show-popular="setVisibility"></shop-populars>
      <section
        v-for="category in menu.Categories"
        :key="category.ID"
        :id="'section-' + category.ID"
      >
        <template
          v-if="!UnavailableCategories.includes(category.ID.toString())"
        >
          <div class="row" v-if="porductToShow(category).length > 0">
            <div
              id="combos"
              class="category-title"
              :style="getStyle()"
              v-html="formatCategoryTitle(getCategoryName(category))"
            ></div>
            <div
              class="category-title"
              :style="getStyle()"
              v-if="category.Description"
              style="padding-top: 0"
            >
              <div v-html="getCategoryDescription(category)"></div>
            </div>
          </div>
          <div
            v-for="product in porductToShow(category)"
            :key="product.ID"
            class="row"
          >
            <Product
              :product="menu.Products[product.ProductID]"
              :modifiers="menu.ModifierGroups"
              :category="product"
              :parent-category="category"
              :key="product.ID"
              :status="getStatus(product)"
              v-show="product"
            />
          </div>
        </template>
      </section>
      <div class="notmatchsearch" v-if="getcountproduct == 0">
        {{ $t("message.Nomatchingproducts") }}
      </div>
    </div>
    <div v-else>
      <message />
    </div>
  </div>
</template>

<script>
import Product from "./ProductMobile";
import shared from "../../../sharedscripts/shop/products/ProductList";
import { mapGetters } from "vuex";
import Message from "../../shared/Message";
import ShopPopulars from "../partials/ShopPopulars";

export default {
  data() {
    return {
      popularStatus: true,
      populars: [],
      scrollheight: document.documentElement.clientHeight,
    };
  },
  name: "ProductList",
  components: { Product, Message, ShopPopulars },
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
    showSearchBox: {
      type: Boolean,
      default: false,
    },
    filterText: {
      type: String,
    },
    ShowPopular: {
      type: Boolean,
      default: false,
    },
    ShowReorder: {
      type: Boolean,
      default: false,
    },
    storeId: {
      type: String,
      required: false,
    },
  },

  created() {
    this.$root.$refs.Productlist = this;
  },
  computed: {
    ...mapGetters([
      "mobileStyles",
      "getDietarySelection",
      "viewConfig",
      "UnavailableCategories",
      "productStatuses",
      "getAddToCartOpen",
    ]),
    getscrollheight: function () {
      return this.scrollheight - 159;
    },
    getcountproduct() {
      var count = 0;
      if (this.menu.Categories && this.menu.Categories.length > 0) {
        this.menu.Categories.forEach((element) => {
          if (element && element.SubMenuItems) {
            var items = this.porductToShow(element);
            count += items.length;
          }
        });
      }
      return count;
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
    getCartOpen() {
      return this.getAddToCartOpen;
    },
  },
  methods: {
    ...shared.methods,
    setVisibility(isVisible) {
      this.$emit("show-popular", isVisible);
    },
    getStyle() {
      var style = [];
      if (this.showNewUi) {
        return style;
      }
      style.push(this.mobileStyles.primaryBackgroundColour);
      style.push(this.mobileStyles.textColour);
      return style;
    },
    porductToShow(category) {
      var items = category.SubMenuItems.filter(
        (p) =>
          !this.filterText ||
          p.Name.toUpperCase().indexOf(this.filterText.toUpperCase()) > -1
      );
      if (this.getDietarySelection.Allergy.length > 0) {
        items = items.filter(
          (p) =>
            this.getDietarySelection.Allergy.filter((a1) =>
              p.ProductAllergy.some((a2) => a2 == a1.Id)
            ).length == this.getDietarySelection.Allergy.length
        );
      }
      if (this.getDietarySelection.Intolerance.length > 0) {
        items = items.filter(
          (p) =>
            this.getDietarySelection.Intolerance.filter((a1) =>
              p.ProductIntolerance.some((a2) => a2 == a1.Id)
            ).length == this.getDietarySelection.Intolerance.length
        );
      }
      if (this.getDietarySelection.Preference.length > 0) {
        items = items.filter(
          (p) =>
            this.getDietarySelection.Preference.filter((a1) =>
              p.ProductPreference.some((a2) => a2 == a1.Id)
            ).length == this.getDietarySelection.Preference.length
        );
      }
      return items;
    },
    getStatus(product) {
      return this.productStatuses[product.ProductID] || 0;
    },
  },
};
</script>
